export const TRANSFERS_BLOTTER_PREFIX = 'principal/transfers';
export const BLOTTER_ID_RECENT_TRANSFERS = `${TRANSFERS_BLOTTER_PREFIX}/recent-transfers`;
